import lrDepartment from './_src/lrDepartment.vue'
lrDepartment.install = function(Vue) {
  Vue.component(lrDepartment.name, lrDepartment)
}

export default lrDepartment